import React from 'react';
// components
import HeaderFull from '@exp/common/src/components/header/HeaderFull';
import Footer from '@exp/common/src/components/footer/Footer';

//styles
import '../styles/global/bootstrap.scss';
import '@exp/common/src/styles/bootstrap-no-purge.scss';
import { ILayoutCommon } from '@exp/common/src/interfaces/generic';
interface LayoutProps extends ILayoutCommon {
  homepage?: boolean;
  className?: string;
}

class LayoutFull extends React.Component<LayoutProps> {
  constructor(props: LayoutProps) {
    super(props);
  }

  render() {
    return (
      <>
        <HeaderFull />
        <main
          id="main"
          {...(this.props.className ? { className: this.props.className } : {})}>
          {this.props.children}
        </main>
        <Footer tradeMarkFootNote={this.props.tradeMarkFootNote} />
      </>
    );
  }
}

export default LayoutFull;
